import gql from 'graphql-tag';

export const updateTargetTimeRule = gql`
  mutation updateTargetTimeRule($input: InputUpdateTargetTimeRule!) {
    updateTargetTimeRule(input: $input) {
      id
      groupId
      category
      issue
      targetResponseSeconds
      targetCompletionSeconds
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
  }
`;
